import { DefaultService } from '@common/references/default.service';
import { inject, Injectable } from '@angular/core';
import {  ReferenceField } from '@common/references/reference-field';
import { PaymentsFormComponent } from '@modules/universal-billing/accounting/payments/payments-form/payments-form.component';
import { environment } from '@environments/environment';
import { TranslateService } from '@ngx-translate/core';
import urlJoin from 'url-join';
import { Observable } from 'rxjs';
import { ResponseSuccess } from '@shared/components/classes/page-result';
import { map } from 'rxjs/operators';
import { Balance } from '@modules/universal-billing/renters/renters-details/balance/balance.interfaces';

@Injectable({providedIn: "root"})
export class BalanceService extends DefaultService<Balance> {
  backendName = 'balances';
  title = 'BALANCE.BALANCES';
  formComponent = PaymentsFormComponent;
  translate = inject(TranslateService);

  fields: ReferenceField[] = [
    {
      fieldName: 'collapse',
      label: '',
      width: '5%'
    },
    {
      fieldName: 'period',
      label: 'PAYMENT.PAYMENT_DATE',
      iconClass: 'las la-calendar-alt',
    },
    {
      fieldName: 'renter',
      label: 'BALANCE.TENANT',
      iconClass: 'las la-user',
    },
    {
      fieldName: 'apartment',
      label: 'RESIDENTS.APARTMENT',
      iconClass: 'las la-tags',
      fieldValue: 'apartmentName'
    },
    {
      fieldName: 'invoiceAmount',
      label: 'BALANCE.EXPECTED_AMOUNT_GROSS',
      iconClass: 'las la-euro-sign',
      viewType: 'money',
    },
    {
      fieldName: 'paidAmount',
      label: 'BALANCE.RECEIVED_AMOUNT_GROSS',
      iconClass: 'las la-euro-sign',
      viewType: 'money',
    },
    {
      fieldName: 'difference',
      label: 'BALANCE.DIFFERENCE_GROSS',
      iconClass: 'las la-euro-sign',
      viewType: 'money',
    },
    {
      fieldName: 'actions',
      label: 'READINGS.ACTIONS',
    },
  ];
  hasActions = false;
  hasAdd = false;
  hasDelete = false;
  hasView= false;
  hasEdit= false;

  getUrl(): string {
    return urlJoin(environment.apiUrl, 'v1/balances');
  }
  getList(params: any = {}): Observable<Balance[]> {
    return this._http.get<ResponseSuccess<Balance[]>>(this.getUrl(), {params}).pipe(map(res => res.data));
  }
}
